import request from '@/utils/request'

// 【新增】医生池-评价列表
// POST /health-doctor-assistant/synthesisedEvaluation/getEvaluationList
// 接口ID：118327677
// 接口地址：https://app.apifox.com/project/3441474/apis/api-118327677

export function getEvaluationList(data) {
  return request({
    url: '/health-doctor-assistant/synthesisedEvaluation/getEvaluationList',
    method: 'post',
    data
  })
}

// 【新增】医生池-评价列表-添加评价
// POST /health-doctor-assistant/synthesisedEvaluation/addEvaluation
// 接口ID：118325591
// 接口地址：https://app.apifox.com/project/3441474/apis/api-118325591

export function addEvaluation(data) {
  return request({
    url: '/health-doctor-assistant/synthesisedEvaluation/addEvaluation',
    method: 'post',
    data
  })
}

// bd池 - 服务数据
export function getServiceData(data) {
  return request({
    url: '/health-assistant/data/center/getServiceData-for-doctor-assistant',
    method: 'get',
    params: data
  })
}
// bd 的业绩数据
export function getbdList(data) {
  return request({
    url: '/health-assistant/data/center/getDataCenterSales-for-doctor-assistant',
    method: 'get',
    params: data
  })
}
// 医生列表
export function getDoctorList(data) {
  return request({
    url: '/health-doctor-assistant/pool/doctor/list',
    method: 'post',
    data
  })
}
// 获取部门列表
export function getDepartmentList(data) {
  return request({
    url: '/health-doctor-assistant/pool/departmentList',
    method: 'get',
    params: data
  })
}
// 获取城市列表
export function getCityList(data) {
  return request({
    url: '/health-doctor-assistant/pool/cityList',
    method: 'get',
    params: data
  })
}
// 患者列表
export function getPatientList(data) {
  return request({
    url: '/health-doctor-assistant/pool/patient/list/V2',
    method: 'post',
    data
  })
}
// 单个患者绑定的医生数
export function getPatientDetail(data) {
  return request({
    url: '/health-doctor-assistant/pool/patient/info/list',
    method: 'post',
    data
  })
}
// 通过ID和类型获取用户信息
export function getUserInfoByType(data) {
  return request({
    url: '/health-doctor-assistant/pool/user/getUserByIdAndType',
    method: 'get',
    params: data
  })
}

// 预校验主动回访患者
export function checkPatientsForActiveFollowup(data) {
  return request({
    url: '/health-doctor-assistant/active-followup/check-patients',
    method: 'post',
    data
  })
}

// 加入主动回访池
export function joinActiveFollowupPool(data) {
  return request({
    url: '/health-doctor-assistant/active-followup/join',
    method: 'post',
    data
  })
}

// 按多对医患关系加入主动回访池（支持一次提交不同医生下的患者）
export function joinActiveFollowupPairs(data) {
  return request({
    url: '/health-doctor-assistant/active-followup/join-pairs',
    method: 'post',
    data
  })
}

// 查询主动回访健管列表
export function getDoctorAssistantList(data) {
  return request({
    url: '/health-doctor-assistant/active-followup/da-list',
    method: 'get',
    params: data
  })
}
// 获取药品数据
export function searchDrugOptions(data) {
  return request({
    url: '/health-doctor-assistant/pool/patient/sku-names',
    method: 'get',
    params: data
  })
}
